import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";

import { get } from "svelte/store";

import type { Distributor } from "@shared/types/Distributor";
import type { Suggestion } from "@shared/types/Suggestion";

const exactSearch = (name: string, field: string, id: number) => {
  return {
    params: {
      search: name,
      st: field,
      si: id.toString(),
    },
  };
};

const defaultSuggestion = (suggestion: Suggestion) => {
  const params = {};
  params[suggestion.field] = suggestion.id;
  return { params };
};

const distributorSuggestion = (suggestion: Suggestion) => {
  const distributor: Distributor = get(DistributorsStore).find(d => d.id === suggestion.id);
  if (distributor) {
    return { params: { distributors: [distributor.id] } };
  } else {
    return { params: { search: suggestion.name } };
  }
};

const sponsoredContentSuggestion = (suggestion: Suggestion) => {
  const slug = suggestion.slug;
  if (slug) {
    return { params: { slug }, path: "/sc/:slug" };
  } else {
    return { params: { search: suggestion.name } };
  }
};

const collectionSuggestion = (suggestion: Suggestion) => {
  if (suggestion.field_ext === "sponsored_content") {
    return sponsoredContentSuggestion(suggestion);
  } else {
    return { params: { tagName: suggestion.name, tagId: suggestion.id } };
  }
};

export const suggestionRouting = (suggestion: Suggestion): { params: object; path?: string } => {
  if (!suggestion.id) {
    return { params: { search: suggestion.name } };
  }

  switch (suggestion.field) {
    case "distributor": {
      return distributorSuggestion(suggestion);
    }
    case "brand_family": {
      return exactSearch(suggestion.name, suggestion.field, suggestion.id);
    }
    case "product_name": {
      return exactSearch(suggestion.name, "product_line", suggestion.id);
    }
    case "collection": {
      return collectionSuggestion(suggestion);
    }
    case "product_type": {
      return { params: { type: suggestion.id } };
    }
    case "supplier": {
      return {
        params: {
          manufacturerId: suggestion.id,
          manufacturerName: suggestion.name,
        },
      };
    }
    case "raw_materials": {
      return {
        params: {
          rawMaterial: suggestion.id,
        },
      };
    }
    default: {
      return defaultSuggestion(suggestion);
    }
  }
};
